import { RadioGroupItemProps } from './radioGroupItemProps.interface';

export interface RadioGroupProps<T> {
  groupName: string;
  standard: RadioGroupItemProps<T>[];
  separatorLabelKey?: string;
  additional?: RadioGroupItemProps<T>[];
}
